module.exports = __webpack_public_path__ + "img/icons/loom-link-copied-aa62889e9ccb41af3d65f3ab83959957.svg";